import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

function ImageViewerModal({
  open,
  onClose,
  imageList,
  activeImageIndex,
  onPrevImage,
  onNextImage,
}) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      aria-labelledby="image-viewer-dialog-title"
    >
      <DialogTitle id="image-viewer-dialog-title">
        <IconButton
          aria-label={t("news.closeImageModalAria")}
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          p: 0,
          textAlign: "center",
          position: "relative",
          bgcolor: "background.paper",
        }}
      >
        {imageList.length > 0 && (
          <>
            {/* Current Image */}
            <Box
              component="img"
              src={imageList[activeImageIndex]?.url}
              alt={t("news.imageAlt", {
                name:
                  imageList[activeImageIndex]?.display_name ||
                  t("news.unknownImage"),
              })}
              sx={{
                width: "100%",
                height: "auto",
                maxHeight: "80vh",
                objectFit: "contain",
                borderRadius: 2,
                transition: "all 0.4s ease",
              }}
              aria-label={t("news.imageAria", {
                name:
                  imageList[activeImageIndex]?.display_name ||
                  t("news.unknownImage"),
              })}
            />

            {/* Prev Button */}
            {activeImageIndex > 0 && (
              <IconButton
                onClick={onPrevImage}
                sx={{
                  position: "absolute",
                  left: 16,
                  top: "50%",
                  transform: "translateY(-50%)",
                  backgroundColor: "background.paper",
                  "&:hover": { backgroundColor: "action.hover" },
                }}
                aria-label={t("news.prevImageAria")}
              >
                {"<"}
              </IconButton>
            )}

            {/* Next Button */}
            {activeImageIndex < imageList.length - 1 && (
              <IconButton
                onClick={onNextImage}
                sx={{
                  position: "absolute",
                  right: 16,
                  top: "50%",
                  transform: "translateY(-50%)",
                  backgroundColor: "background.paper",
                  "&:hover": { backgroundColor: "action.hover" },
                }}
                aria-label={t("news.nextImageAria")}
              >
                {">"}
              </IconButton>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}

ImageViewerModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  imageList: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      display_name: PropTypes.string,
    })
  ).isRequired,
  activeImageIndex: PropTypes.number.isRequired,
  onPrevImage: PropTypes.func.isRequired,
  onNextImage: PropTypes.func.isRequired,
};

export default ImageViewerModal;
